var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPriceMoney(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9212 43.7475C10.1287 43.1263 0 37.3463 0 28.75C0 23.7625 3.4925 20 8.125 20C10.8337 20 13.75 21.6137 13.75 25.1563C13.75 28.0075 11.8863 30 9.21875 30C7.22375 30 5 28.46 5 26.25H7.5C7.5 26.8463 8.4 27.5 9.21875 27.5C11.1038 27.5 11.25 25.705 11.25 25.1563C11.25 23.1963 9.56625 22.5 8.125 22.5C4.91875 22.5 2.5 25.1863 2.5 28.75C2.5 35.8775 11.4375 40.7038 20.0788 41.2525L19.9212 43.7475ZM40.0788 43.7475L39.92 41.2525C48.5625 40.7038 57.5 35.8775 57.5 28.75C57.5 25.1863 55.0812 22.5 51.875 22.5C50.4338 22.5 48.75 23.1963 48.75 25.1563C48.75 25.705 48.8963 27.5 50.7812 27.5C51.6 27.5 52.5 26.8463 52.5 26.25H55C55 28.46 52.7762 30 50.7812 30C48.1138 30 46.25 28.0075 46.25 25.1563C46.25 21.6137 49.1662 20 51.875 20C56.5075 20 60 23.7625 60 28.75C60 37.3463 49.8713 43.1263 40.0788 43.7475ZM33.75 50V51.25H26.25V50L23.75 35H36.25L33.75 50Z",
    fill: "#FEB705"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 53.75H20V52.25C20 51.4212 26.25 50 26.25 50H33.75C33.75 50 40 51.4212 40 52.25V53.75Z",
    fill: "#FFD217"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 7.5H40V31.25H20V7.5Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3008 8.5H38.8008V29.75H21.3008V8.5ZM18.8008 6V32.25H41.3008V6H18.8008Z",
    fill: "#00B0A6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M21.25 22.5H38.75V25H21.25V22.5Z",
    fill: "#192643"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0508 7.25V11.6113C20.5745 12.0063 21.2195 12.25 21.9258 12.25C23.652 12.25 25.0508 10.8513 25.0508 9.125C25.0508 8.41875 24.807 7.77375 24.412 7.25H20.0508ZM35.6895 7.25C35.2945 7.77375 35.0508 8.41875 35.0508 9.125C35.0508 10.8513 36.4495 12.25 38.1758 12.25C38.882 12.25 39.527 12.0063 40.0508 11.6113V7.25H35.6895Z",
    fill: "#00B0A6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 46.25H27.5C18.525 46.25 11.25 38.975 11.25 30V25H48.75V30C48.75 38.975 41.475 46.25 32.5 46.25Z",
    fill: "#FFD217"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.753 14.9707H33.6226V16.3252H27.753V14.9707ZM26.3984 17.2283H33.6226V18.5828H26.3984V17.2283Z",
    fill: "#00B0A6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4036 21.2934H28.4302C30.0651 21.2934 31.8166 20.023 31.8166 18.1321C31.8166 16.2411 30.0651 14.9707 28.4302 14.9707H26.3984V16.3256H28.4302C29.2822 16.3256 30.462 16.9538 30.462 18.1321C30.462 19.3103 29.2822 19.9385 28.4302 19.9385H26.3984V21.3851L31.1659 25.358H33.2808L28.4036 21.2934Z",
    fill: "#00B0A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceMoney);
export default __webpack_public_path__ + "static/media/price_money.d31cdedd8a39404330c5be3a6392b0a9.svg";
export { ForwardRef as ReactComponent };